import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UpdateDashboardComponentValidationSchema } from '../../schemas/dashboards/dashboardComponent';

interface UseUpdateDashboardComponentsProps {
  dashboardId: string | undefined;
  dashboardComponentId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    UpdateDashboardComponentValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateDashboardComponents = ({
  dashboardId,
  dashboardComponentId,
  options,
}: UseUpdateDashboardComponentsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateDashboardComponent', dashboardComponentId],
    mutationFn: (form) => {
      return privateAxios.put(`/dashboards/${dashboardId}`, {
        dashboard: {
          components_attributes: [
            {
              id: dashboardComponentId,
              generator_properties: {
                kind: form?.kind?.value,
              },
            },
          ],
        },
      });
    },
    ...options,
  });
}
